import { useCallback } from 'react';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import UserUtils from '@/utils/user';
import classNames from './TheSidebar.module.scss';
import classes from 'classnames';
import { View } from '@/types/common';

import TeacherSidebar from './TeacherSidebar';
import UserSidebar from './UserSidebar';

interface TheSidebarProps {
  viewTabs: View[];
  emitSelectView: (view: View) => void;
  isCollapsed?: boolean;
  onCollapsedChange?: (collapsed: boolean) => void;
}

const TheSidebar = ({
  viewTabs,
  emitSelectView,
  isCollapsed = false,
  onCollapsedChange,
}: TheSidebarProps) => {
  const { user } = useAppSelector(authSelector);
  const isTeacher = UserUtils.isTeacher(user);

  const handleToggleCollapse = useCallback(
    (collapsed: boolean) => {
      onCollapsedChange?.(collapsed);
    },
    [onCollapsedChange]
  );

  return (
    <div
      className={classes(classNames.theSidebar, {
        [classNames.theSidebarTeacher]: isTeacher,
        [classNames.collapsed]: isCollapsed && isTeacher,
      })}
    >
      {isTeacher ? (
        <TeacherSidebar
          viewTabs={viewTabs}
          emitSelectView={emitSelectView}
          isCollapsed={isCollapsed}
          onToggleCollapse={handleToggleCollapse}
        />
      ) : (
        <UserSidebar viewTabs={viewTabs} emitSelectView={emitSelectView} />
      )}
    </div>
  );
};

export default TheSidebar;
